import { ModuleRoute } from 'module-routes';

export enum CashFlowPath {
  CashClose = 'cash-close',
  CashCloseHistory = 'cash-close-history',
}

export const CashFlowModuleRoutes = new Map<CashFlowPath, <T>(id?: T) => string>([
  [CashFlowPath.CashClose, () => `${ModuleRoute.CashFlow}/${CashFlowPath.CashClose}`],
  [CashFlowPath.CashCloseHistory, () => `${ModuleRoute.CashFlow}/${CashFlowPath.CashCloseHistory}`],
]);

export const getCashFlowModuleRoutes = <T>(route: CashFlowPath, id?: T): string => {
  const routeFunction = CashFlowModuleRoutes.get(route);
  if (routeFunction) {
    return routeFunction(id);
  }
  throw new Error(`Route ${route} not found}`);
};
